// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2yYTN","log":"ModalInventoryLogs_log__AuI8I","date":"ModalInventoryLogs_date__Tr7Jh","userName":"ModalInventoryLogs_userName__3Tg9Y"};